export default function resultsClusterMarkup(cbsa, cluster) {
  return `
  <div id="no-results">
  <div class=""><span>The survey’s sample size is not large enough to display results for this area alone, but you can explore survey results for a group of areas similar to and including ${cbsa.full_name.replace(
    /--/g,
    "—"
  )}.</span></div>
    <button class="ui button" id="show-cluster">View group results</button>
  </div>
  <div class="results-container no-show">
        <div class="sticky-container">
          <div class="ui sticky sticky__nav">
            <ul>
              <li class="nav-element" data-section="sources">Providers and pathways</li>
              <li class="nav-element" data-section="topics">Local news topics</li>
              <li class="nav-element" data-section="community">Connection to community</li>
              <li class="nav-element" data-section="assessments">Assessments of local media</li>
              <li class="nav-element" data-section="methodology">Methodology</li>
            </ul>
          </div>
        </div>
        <div id="results-sections">
          <section class="section section--intro">
            <div class="pre-title">The local news dynamics in</div>
            <h1>Areas like ${cbsa.full_name.replace(/--/g, "—")}</h1>
            <div class=".section--intro__text section--intro__text--cluster">
              ${
                cbsa.CBSA_cluster == 1
                  ? `
              <p>On average, areas like ${
                cbsa.metro_name
              } tend to have more residents with a college degree, a higher median household income and lean more Democratic compared with all CBSAs. For information on how CBSAs are grouped, please <a href="https://www.journalism.org/2019/03/26/local-news-methodology/" target="_blank">see the Methodology</a>.</p>
              <p>Explore the local news habits and attitudes of residents in areas like ${
                cbsa.metro_name
              } below.</p>
              `
                  : ``
              }
              ${
                cbsa.CBSA_cluster == 2
                  ? `
              <p>On average, areas like ${
                cbsa.metro_name
              } tend to have a higher proportion of residents who are Hispanic and a lower proportion of people who live in rural areas compared with all CBSAs. For information on how CBSAs are grouped, please <a href="https://www.journalism.org/2019/03/26/local-news-methodology/" target="_blank">see the Methodology</a>.</p>
              <p>Explore the local news habits and attitudes of residents in areas like ${
                cbsa.metro_name
              } below.</p>
              `
                  : ``
              }
              ${
                cbsa.CBSA_cluster == 3
                  ? `
              <p>On average, areas like ${
                cbsa.metro_name
              } tend to have a higher proportion of black residents, a higher proportion of people whose income is below the poverty line, and a lower median household income compared with all CBSAs. For information on how CBSAs are grouped, please <a href="https://www.journalism.org/2019/03/26/local-news-methodology/" target="_blank">see the Methodology</a>.</p>
              <p>Explore the local news habits and attitudes of residents in areas like ${
                cbsa.metro_name
              } below.</p>
              `
                  : ``
              }
              ${
                cbsa.CBSA_cluster == 4
                  ? `
              <p>On average, areas like ${
                cbsa.metro_name
              } tend to have a larger population, a higher proportion of black residents, and a higher proportion of people with a college degree compared with all CBSAs. For information on how CBSAs are grouped, please <a href="https://www.journalism.org/2019/03/26/local-news-methodology/" target="_blank">see the Methodology</a>.</p>
              <p>Explore the local news habits and attitudes of residents in areas like ${
                cbsa.metro_name
              } below.</p>
              `
                  : ``
              }
              ${
                cbsa.CBSA_cluster == 5
                  ? `
              <p>On average, areas like ${
                cbsa.metro_name
              } tend to resemble the typical CBSA on a range of measures, but have a slightly lower proportion of people whose income is below the poverty line, slightly more newspapers per capita, and a slightly lower proportion of black residents compared with all CBSAs. For information on how CBSAs are grouped, please <a href="https://www.journalism.org/2019/03/26/local-news-methodology/" target="_blank">see the Methodology</a>.</p>
              <p>Explore the local news habits and attitudes of residents in areas like ${
                cbsa.metro_name
              } below.</p>
              `
                  : ``
              }
              ${
                cbsa.CBSA_cluster == 6
                  ? `
              <p>On average, areas like ${
                cbsa.metro_name
              } tend to resemble the typical CBSA on a range of measures, but have a slightly higher proportion of people who live in rural areas, and a slightly lower proportion of people with a college degree compared with all CBSAs. For information on how CBSAs are grouped, please <a href="https://www.journalism.org/2019/03/26/local-news-methodology/" target="_blank">see the Methodology</a>.</p>
              <p>Explore the local news habits and attitudes of residents in areas like ${
                cbsa.metro_name
              } below.</p>
              `
                  : ``
              }
            </div>
          </section>
          <section class="section section--charts" id="sources">
            <h2>How residents in areas like ${
              cbsa.metro_name
            } get local news</h2>
            <p>Americans have a wide range of options when it comes to where and how they get their local news, including the pathways and providers they turn to, their social media news use, and the devices they use to access local news online.</p>
            <div class="chart-super">
              <h3>Preferred pathway to local news</h3>
              <div class="chart__subtitle">% of adults in areas like ${
                cbsa.metro_name
              } who prefer to get their local news via …</div>
              <div class="chart__chart-container" id="LOCAL_PREFER"></div>
            </div>
            <div class="chart-super">
              <h3>Types of local news providers turned to</h3>
              <div class="chart__subtitle">% of adults in areas like ${
                cbsa.metro_name
              } who get local news from each type of provider</div>
              <div class="chart__legend-container">
                <div class="legend">
                  <div class="legend-item">
                    <span class="legend-color purple2"></span><span class="legend-text">Often</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color purple3"></span><span class="legend-text">Sometimes</span>
                  </div>
                  <div class="legend-item">  
                    <span class="legend-color purple4"></span><span class="legend-text">Hardly<br>ever</span>
                  </div>
                  <div class="legend-item">  
                    <span class="legend-color purple5"></span><span class="legend-text">Never</span>
                  </div>
                </div>
              </div>
              <div class="chart__chart-container" id="PROVIDER"></div>
            </div>
            <div class="chart-super">
              <h3>Use of websites and social media for local news</h3>
              <div class="chart__subtitle">% of adults in areas like ${
                cbsa.metro_name
              } who get local news from …</div>
              <div class="chart__legend-container">
                <div class="legend">
                  <div class="legend-item">
                    <span class="legend-color purple2"></span><span class="legend-text">Often</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color purple3"></span><span class="legend-text">Sometimes</span>
                  </div>
                  <div class="legend-item">  
                    <span class="legend-color purple4"></span><span class="legend-text">Hardly<br>ever</span>
                  </div>
                  <div class="legend-item">  
                    <span class="legend-color purple5"></span><span class="legend-text">Never</span>
                  </div>
                </div>
              </div>
              <div class="chart__chart-container" id="LOCNEWSWEB"></div>
            </div>
            <div class="chart-super">
              <h3>Devices used to access local news online</h3>
              <div class="chart__subtitle">Among adults in areas like ${
                cbsa.metro_name
              } who get local news online, % who primarily get it on ...</div>
              <div class="chart chart--pie">
                <div class="chart__legend-container">
                    <div class="legend legend--vertical">
                        <div class="legend-item">
                        <span class="legend-color purple2"></span><span class="legend-text">A mobile device</span>
                        </div>
                        <div class="legend-item">
                        <span class="legend-color purple3"></span><span class="legend-text">A desktop/laptop</span>
                        </div>
                        <div class="legend-item">  
                        <span class="legend-color purple4"></span><span class="legend-text">Both equally</span>
                        </div>
                    </div>
                </div>
                <div class="chart__chart-container" id="LOCAL_DEVICE"></div>
              </div>
            </div>
          </section>
          <section class="section section--charts" id="topics">
            <h2>Local news topics important to people in areas like ${
              cbsa.metro_name
            }</h2>
            <p>One difficult choice local news media must make is which types of stories to emphasize with their resources. People place more importance on some local news topics than others, and they also say that some topics are easier to find information about than others.</p>
            <div class="chart-super">
              <div class="chart__subtitle">% of adults in areas like ${
                cbsa.metro_name
              } who say each local news topic is ...</div>
              <div class="chart__legend-container chart__legend-container--wide">
                  <div class="legend legend--wide">
                      <div class="legend-item">
                      <span class="legend-color purple2"></span><span class="legend-text">Important for daily life</span>
                      </div>
                      <div class="legend-item">
                      <span class="legend-color purple3"></span><span class="legend-text">Important, but not<br> for daily life</span>
                      </div>
                      <div class="legend-item">  
                      <span class="legend-color purple4"></span><span class="legend-text">Interesting to follow</span>
                      </div>
                      <div class="legend-item">  
                      <span class="legend-color purple5"></span><span class="legend-text">Neither interesting<br>nor important</span>
                      </div>
                    </div>
                </div>
              <div class="chart__chart-container" id="TOPICIMPORT"></div>
            </div>
            <div class="chart-super">
              <div class="chart__subtitle">Among adults in areas like ${
                cbsa.metro_name
              } who say each local news topic is important or interesting, % who say it is <b>very easy to stay informed about it</b></div>
              <div class="chart__chart-container" id="TOPICINFO"></div>
            </div>
          </section>
          <section class="section section--charts" id="community">
            <h2>The local news media’s connection to the community</h2>
            <p>At the heart of many current efforts to strengthen public trust and engagement in local news systems is an emphasis on journalists’ connection with the communities they cover. It is important, then, to understand whether Americans feel this connection or not – including how in touch and influential they feel local journalists are and whether they see them as mostly covering the local area as opposed to a nearby city.</p>
            <div class="chart-super">
              <h3>Community connections</h3>
              <div class="chart__subtitle">% of adults in areas like ${
                cbsa.metro_name
              } who say ...</div>
              <div class="text-question bundle">
                <div class="text-question option-container">
                  <div class="text-question option"> 
                    Local journalists are in touch with the community
                  </div>
                  <div class="text-question value">
                    ${cluster["LOCMED_INTOUCH"].answers.values[0].toFixed(
                      0
                    )}<span class="percent-sign">%</span>
                  </div>
                </div>
                <div class="text-question option-container">
                  <div class="text-question option"> 
                  Local journalists are out of touch with the community
                  </div>
                  <div class="text-question value">
                  ${cluster["LOCMED_INTOUCH"].answers.values[1].toFixed(
                    0
                  )}<span class="percent-sign">%</span>
                  </div>
                </div>
              </div>
              <div class="text-question bundle">
                <div class="text-question option-container">
                  <div class="text-question option"> 
                  Local news media have a lot of influence
                  </div>
                  <div class="text-question value">
                    ${cluster["INFLUENCE"].answers.values[0].toFixed(
                      0
                    )}<span class="percent-sign">%</span>
                  </div>
                </div>
                <div class="text-question option-container">
                  <div class="text-question option"> 
                  Local news media do not have much influence
                  </div>
                  <div class="text-question value">
                  ${cluster["INFLUENCE"].answers.values[1].toFixed(
                    0
                  )}<span class="percent-sign">%</span>
                  </div>
                </div>
              </div>
              <div class="text-question bundle">
                <div class="text-question option-container">
                  <div class="text-question option"> 
                  They have spoken with a local journalist
                  </div>
                  <div class="text-question value">
                    ${cluster["TALKJOUR"].answers.values[0].toFixed(
                      0
                    )}<span class="percent-sign">%</span>
                  </div>
                </div>
                <div class="text-question option-container">
                  <div class="text-question option"> 
                  They have not spoken with a local journalist
                  </div>
                  <div class="text-question value">
                  ${cluster["TALKJOUR"].answers.values[1].toFixed(
                    0
                  )}<span class="percent-sign">%</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="chart-super">
              <h3>Local news media coverage</h3>
              <div class="chart__subtitle">% of adults in areas like ${
                cbsa.metro_name
              } who say their local news media mostly cover ...</div>
              <div class="text-question bundle">
                <div class="text-question option-container">
                  <div class="text-question option"> 
                  The area where you live
                  </div>
                  <div class="text-question value">
                    ${cluster["LOCNEWS_COVERAGE1"].answers.values[0].toFixed(
                      0
                    )}<span class="percent-sign">%</span>
                  </div>
                </div>
                <div class="text-question option-container">
                  <div class="text-question option"> 
                  Another area, such as a nearby city
                  </div>
                  <div class="text-question value">
                  ${cluster["LOCNEWS_COVERAGE1"].answers.values[1].toFixed(
                    0
                  )}<span class="percent-sign">%</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section section--charts" id="assessments">
            <h2>How residents in areas like ${
              cbsa.metro_name
            } rate their local news media</h2>
            <p>There are several core job functions of local news media such as accuracy, transparency, fairness and inclusion. People rate the news media’s performance on some of these functions more highly than others, but few choose to express support by paying a local news provider directly.</p>
            <div class="chart-super">
              <h3>Local news media performance</h3>
              <div class="chart__subtitle">% of adults in areas like ${
                cbsa.metro_name
              } who say their local news media do each of the following well</div>
              <div class="chart__chart-container" id="JOBVALUES"></div>
            </div>
            <div class="chart-super">
              <div class="chart__subtitle">
                % of adults in areas like ${
                  cbsa.metro_name
                } who say the local news media do ___ at keeping them informed of the most important local stories of the day
              </div>
              <div class="chart__legend-container center">
                <div class="legend">
                  <div class="legend-item">
                    <span class="legend-color purple2"></span><span class="legend-text">Very well</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color purple3"></span><span class="legend-text">Fairly well</span>
                  </div>
                  <div class="legend-item">  
                    <span class="legend-color yellow2"></span><span class="legend-text">Not too well</span>
                  </div>
                  <div class="legend-item">  
                    <span class="legend-color yellow1"></span><span class="legend-text">Not well at all</span>
                  </div>
                </div>
              </div>
              <div class="chart__chart-container" id="LOCALMEDIA_JOB"></div>
            </div>
            <div class="chart-super">
              <h3>Confidence in main local news source</h3>
              <div class="chart__subtitle">
                % of adults in areas like ${
                  cbsa.metro_name
                } who are ___ confident their main source for local news can get them the information they need
              </div>
              <div class="chart__legend-container center">
                <div class="legend">
                  <div class="legend-item">
                    <span class="legend-color purple2"></span><span class="legend-text">Very</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color purple3"></span><span class="legend-text">Somewhat</span>
                  </div>
                  <div class="legend-item">  
                    <span class="legend-color yellow2"></span><span class="legend-text">Not very</span>
                  </div>
                  <div class="legend-item">  
                    <span class="legend-color yellow1"></span><span class="legend-text">Not at all</span>
                  </div>
                </div>
              </div>
              <div class="chart__chart-container" id="MAIN_CONF"></div>
            </div>
            <div class="chart-super">
              <h3>Paying for local news</h3>
              <div class="chart__subtitle">% of adults in areas like ${
                cbsa.metro_name
              } who have ___ in the past year</div>
              <div class="text-question bundle">
                <div class="text-question option-container">
                  <div class="text-question option"> 
                  Paid for local news
                  </div>
                  <div class="text-question value">
                    ${cluster["LOCAL_NEWS_PAY"].answers.values[0].toFixed(
                      0
                    )}<span class="percent-sign">%</span>
                  </div>
                </div>
                <div class="text-question option-container">
                  <div class="text-question option"> 
                  Not paid for local news
                  </div>
                  <div class="text-question value">
                  ${cluster["LOCAL_NEWS_PAY"].answers.values[1].toFixed(
                    0
                  )}<span class="percent-sign">%</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section section--methodology" id="methodology">
            <h2>Methodology</h2>
            <p>The estimates shown here were produced using statistical models that combine survey responses with other data on CBSA characteristics obtained from the U.S. Census Bureau and other sources.  The use of statistical modeling makes it possible to produce more precise estimates for much smaller geographic areas than would otherwise be possible. Even within a survey as large as this one, this modeling is necessary for the analysis of smaller CBSAs. Additionally, the modeled estimates do not include a category for those who skipped the question. This differs from the national estimates in the report which include the “refused” category, as is common in standard survey analyses. As a result, the estimates shown may differ from estimates obtained using only the weighted survey data. For more details on how these modeled estimates were calculated, <a href="https://www.journalism.org/2019/03/26/local-news-methodology/" target="_blank">see the Methodology</a>.</p>
            <p>For the group of CBSAs that includes ${cbsa.full_name.replace(
              /--/g,
              "—"
            )}, the estimates shown are for a group of areas that are similar to ${
    cbsa.metro_name
  }, not estimates specific to ${
    cbsa.metro_name
  }. The average modeled margin of error for these estimates is plus or minus ${
    cluster.average_moe
  } percentage points, although the precision of individual estimates can vary. To see the precision for specific estimates for this group of CBSAs, <a href="//assets.pewresearch.org/interactives/journalism/2019/local-news-habits/spreadsheets/local_news_mrp_cluster_${
    cbsa.CBSA_cluster
  }.xlsx">download the accompanying spreadsheet</a>.</p>
  <p>Pew Research Center is a subsidiary of The Pew Charitable Trusts, its primary funder. This project was made possible by The Pew Charitable Trusts, which received support from the Google News Initiative.</p>
          </section>
        </div>
        <div></div>
        </div>
`;
}
